import { createStore } from 'stimulus-store';

export const buildingStore = createStore({
    name: 'buildingStore',
    type: Object,
    initialValue: {}
});